module.exports = __webpack_public_path__ + "static/media/ZR.9db2ca5b.PNG";